module.exports = __webpack_public_path__ + "static/media/StripesCyan.d5324cc8.png";